import { FETCH_ACCOUNT_ERROR, FETCH_ACCOUNT_SUCCESS, REQUEST_FETCH_ACCOUNT } from './actionTypes';

export const requestFetchAccount = () => ({ type: REQUEST_FETCH_ACCOUNT });

export const fetchAccountSuccess = account => ({ type: FETCH_ACCOUNT_SUCCESS, payload: account });

export const fetchAccountError = error => ({ type: FETCH_ACCOUNT_ERROR, error });
